import React from 'react';
import SubViewOptions from '../SubViewOptions';
import SearchSimple from '../../../../../../components/SearchSimples/SearchSimple';
import CustomExpandableTable from '../../../../../../components/table/CustomExpandableTable';
import DeleteModal from '../../../../../Modals/DeleteModal';
import ByDepartmentTableApp from './Functionality/ByDepartmentTableApp';
import NotInformation from "../../../../../../components/NotInformation";
import { STATUS_MODEL } from "../../../../../../enums/statusEnum";
import ConfirmModal from "../../../../Visitor/Invitation/Modal/ConfirmModal";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ByDepartmentTable = ({
    subView,
    changeSubViewManage,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    modified,
    setModified,
    registerAction,
    activeStep,
    selectForDelete,
    setSelectForDelete,
}) => {
    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        results,
        setResults,
        rowsPerPage,
        columns,
        handleRowExpand,
        deleteModalShow,
        handleDeleteModalClose,
        handleDeleteSelected,
        handleCreate,
        selectedItem,
        showActiveInactiveModal,
        setShowActiveInactiveModal,
        handleStatusChange,
        renderExpandedRow,
        canCreate,
        canDelete
    } = ByDepartmentTableApp({
        searchElement,
        setBodyForExport,
        option,
        modified,
        setModified,
        selectedList: selectForDelete,
        setSelectedList: setSelectForDelete,
        registerAction,
        activeStep,
        subView
    });



    return (
        <>
            <div className='d-flex mb-4'>
                <SubViewOptions subView={subView} changeSubViewManage={changeSubViewManage} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        search={search}
                        setSearch={setSearch}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                    />
                </div>
            </div>

            {results?.content?.length > 0 ?
            <CustomExpandableTable
                id={tableId}
                columns={columns}
                rows={results?.content || []}
                renderExpandedRow={renderExpandedRow}
                renderOptionsMenu={getActionsButtons}
                onRowExpand={handleRowExpand}
                selectedList={selectForDelete}
                handleCheckboxChange={handleCheckboxChange}
                handleDeleteAll={handleDeleteAll}
                rowsPerPage={rowsPerPage}
                checkbox={canDelete}
            /> :
                <NotInformation
                    className={"mt-4"}
                    card={true}
                    text={ t('you_haven_not_created_any_department_payroll_policies_yet')}
                    showButton={canCreate}
                    buttonId={'btn_bdt_add_department_rule'}
                    buttonOnclick={handleCreate}
                    buttonTrans={'add_department_rule'}
                    searchElement={searchElement}
                />
            }
            {pagination()}

            {deleteModalShow && (
                <DeleteModal
                    show={deleteModalShow}
                    onHide={handleDeleteModalClose}
                    onClickFn={handleDeleteSelected}
                    data={selectedItem ? [selectedItem] : results.content.filter(r => selectForDelete.includes(r.id))}
                    title_modal={t('delete_by_department_policy')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('by_department_policy')}
                    buttonCancelText={'cancel'}
                />
            )}

            <ConfirmModal
                show={showActiveInactiveModal}
                onHide={() => setShowActiveInactiveModal(false)}
                onClickFn={handleStatusChange}
                title_modal={parseInt(selectedItem?.statusId) === STATUS_MODEL.ACTIVE_COMPANY ? 'deactivate_policy' : 'activate_policy'}
                description={parseInt(selectedItem?.statusId) === STATUS_MODEL.ACTIVE_COMPANY
                    ? t('are_you_sure_you_want_to_deactivate_the_policy')
                    : t('are_you_sure_you_want_to_activate_the_policy')}
            />
        </>
    );
};

export default ByDepartmentTable;
